import { render, staticRenderFns } from "./MortalityDetails.vue?vue&type=template&id=5ce45a22&scoped=true"
import script from "./MortalityDetails.vue?vue&type=script&lang=js"
export * from "./MortalityDetails.vue?vue&type=script&lang=js"
import style0 from "./MortalityDetails.vue?vue&type=style&index=0&id=5ce45a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce45a22",
  null
  
)

export default component.exports